var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsObject, IsString, IsUUID } from 'class-validator';
import { OfficeLocationStub, } from '../../offices/index.js';
/**
 * @deprecated Use OfficeLocationBrandingResponseDto if you don't need nested relations.
 */
export class OfficeLocationBrandingFullSizeDto {
    id;
    createdAt;
    updatedAt;
    officeLocationId;
    officeLocation;
    officeId;
    office;
    logoFile;
    primaryColor;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationBrandingFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], OfficeLocationBrandingFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], OfficeLocationBrandingFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationBrandingFullSizeDto.prototype, "officeLocationId", void 0);
__decorate([
    Expose(),
    IsObject(),
    Type(() => OfficeLocationStub),
    __metadata("design:type", Function)
], OfficeLocationBrandingFullSizeDto.prototype, "officeLocation", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationBrandingFullSizeDto.prototype, "officeId", void 0);
__decorate([
    Expose(),
    IsObject(),
    __metadata("design:type", Function)
], OfficeLocationBrandingFullSizeDto.prototype, "office", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", Object)
], OfficeLocationBrandingFullSizeDto.prototype, "logoFile", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", Object)
], OfficeLocationBrandingFullSizeDto.prototype, "primaryColor", void 0);
//# sourceMappingURL=office-location-branding.full-size.dto.js.map